import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import dayjs from 'dayjs'
import {
  Box,
  Breadcrumbs,
  Button,
  Container,
  Fade,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import Layout from '@/components/Layout/Layout'
import HeroSection from '@/components/Hero/HeroSection'
import DateRangeForm from '@/components/DateRangeForm/DateRangeForm'
import useShopStyle from '@/components/Shop/Shop.style'
import {
  getProductsBySlug,
  getProductVariantAvailability,
  saveFetchedProduct,
  resetSingleProduct,
} from '@/redux/actions/products'
import * as productsService from '@/redux/services/products'
import {
  Cart,
  GAEvent,
  Product,
  shortProduct,
  TBreadCrumbItem,
} from '@/typings/base'
import TakeBackSize from '@/components/Sizes/TakeBackSize'
import Glider, { GliderMethods } from 'react-glider'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import { getTranslations } from '@/i18n'
import { useTranslation } from 'react-i18next'
import {
  btnOptions,
  checkProductAvailability,
  checkStockQuantity,
  columnGridLayout,
  columnLayout,
  getSkus,
  numberToPrice,
  productLowestPrice,
  setFullLocale,
  thumbnailRatio,
  getProductImageKitSettings,
} from '@/utils/utils'
import Skeleton from '@material-ui/lab/Skeleton'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import ProductCard from '@/components/Shop/ProductCard'
import { addToCartUtility } from '@/utils/addToCart'
import ImgKitHandler from '@/components/ImgKitHandler/ImgKitHandler'
import ChangeStoreModal from '@/components/InStore/ChangeStoreModal'
import CMSText, { prismicText } from '@/components/Global/CMSText'
import BottomMenuLinks from '@/components/Shop/BottomMenuLinks'
import CommonInformations from '@/components/Shop/CommonInformations'
import TakeBackAndRentTab from '@/components/Shop/TakeBackAndRentTab'
import InStoreSoldOut from '@/components/InStore/InStoreSoldOut'
import Selectors from '@/components/Products/Selectors'
import ProductTitle from '@/components/Products/ProductTitle'
import ProductDynamicAlert from '@/components/Products/ProductDynamicAlert'
import { getTakeBackStock } from '@/redux/actions/takeBack'
import BackInStockAlert from '@/components/BackInStockAlert/BackInStockAlert'
import {
  hidePricingOnGhostUser,
  imageFixInProductDetail,
  isDateToDate,
  isSecondHandOnly,
  isSubscription,
  NEW_BUT_REPAIRED_TAXON_SLUG,
  store,
} from '@/utils/constants'
import {
  createProductsQualityArrayBySize,
  currentQualityInCart,
  getChosenQualityObject,
  getSecondHandImageForRelatedProduct,
  handlePreselectedSizeAndCondition,
  handleTakeBackOriginalPrice,
} from '@/utils/takeBack'
import { getCurrentProductTypeInCart } from '@/utils/cart'
import NoMixedBasketModal from '@/components/Products/NoMixedBasketModal'
import { useCart } from '@/hooks/useCart'
import { useTakeback } from '@/hooks/useTakeback'
import { createClient, getSingleDocument, getByUID } from '@/prismicio'
import { RootState } from '@/redux/reducers/rootReducer'
import { InferGetStaticPropsType } from 'next/types'
import { GetMapDispatchTypes } from '@/interfaces/common/redux'
import { PrismicPage } from '@/interfaces/common/prismicPage'
import { PrismicFunnel } from '@/interfaces/common/prismicFunnel'
import { PrismicBasket } from '@/interfaces/common/prismicBasket'
import { SecondHandDescriptionPosition } from '@/interfaces/common/prismicTakeBack'
import { useProductStyles } from '@/components/Products/Product.styles'
import { SAVE_PRISMIC_DOCUMENTS } from '@/redux/actions/prismic'
import { getAvailableFilteredConditions } from '@/utils/takeBackFiltersConditions'
import { getLowestConditionByConditions } from '@/utils/filters'
import {
  clearItemVariantFromGAParamsIfNotChalhoub,
  getViewItemGtmData,
  isChalhoub,
  safeDataLayerPush,
  tracker,
} from '@/utils/gtag'
import { getTaxons, getTaxonsSizes } from '@/redux/actions/taxons'
import Link from 'next/link'
import HrefLangLinks from '@/components/HrefLangLinks'
import { PrismicGeneralConfig } from '@/interfaces/common/prismicGeneralConfig'
import {
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
} from '@material-ui/icons'
import { addToWishList } from '../../redux/actions/wishList'
import { removeFromWishList } from '../../redux/actions/wishList'
import CMSTextOrImage from '@/components/Global/CMSTextOrImage'
import { getPricingWithTaxInfo } from '@/utils/taxPricing'
import { createReservation } from '@/redux/actions/reservations'
import ReservationConfirmModal from '@/components/Reservations/ReservationConfirmModal'
import { Alert } from '@mui/material'
import LoginToSeePriceRow from '@/components/Products/LoginToSeePriceRow'
import {
  getSavedProductImages,
  saveProductImages,
} from '@/utils/productImagesStorage'

const THUMBS_BY_SLIDES = 4

const formatBreadCrumbTaxonName = (taxonName: string) => {
  if (process.env.STORE === 'vaude') {
    return taxonName
  }

  return taxonName.charAt(0).toUpperCase() + taxonName.toLowerCase().slice(1)
}

type TProductProps = ReturnType<typeof mapStateToProps> &
  InferGetStaticPropsType<typeof getStaticProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const Produit = ({
  main,
  funnel,
  product,
  inStoreText,
  promotions,
  productSettings,
  stock,
  getProductsBySlug,
  getTakeBackStock,
  parameters,
  getProductVariantAvailability,
  getTaxons,
  taxons,
  takeback,
  basket,
  skiText,
  takeBackLP,
  stores,
  accountRes,
  faqRes,
  banner,
  shop,
  pageData,
  products,
  addToWishList,
  removeFromWishList,
  getTaxonsSizes,
  userIsLoggedIn,
  enableBraSizeGuide,
}: TProductProps) => {
  const {
    addProductToCart,
    changeProductQuantityInCart,
    removeProductFromCart,
  } = useCart()
  const classes = useShopStyle({})
  const productClasses = useProductStyles()
  const router = useRouter()
  const theme = useTheme()
  const { productCheckState } = useTakeback()
  const slug = router.query
  const cart: Cart = useSelector((state) => state.cart)
  const [quantity, setQuantity] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [availability, setAvailability] = useState(false)
  const [takeBackAvailability, setTakeBackAvailability] = useState(false)
  const [openInStoreModal, setOpenInStoreModal] = useState(false)
  const [minPrice, setMinPrice] = useState(0)
  const [originalPrice, setOriginalPrice] = useState(0)
  const [takeBackPrice, setTakeBackPrice] = useState(0)
  const [takeBackPriceMinTtc, setTakeBackPriceMinTtc] = useState(0)
  const [takeBackPriceMin, setTakeBackPriceMin] = useState(0)
  const { t } = useTranslation()
  const { trackEvent, pushInstruction, trackPageView } = useMatomo()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const showRelatedProducts = productSettings?.data.display_associations
  const relatedProductsTitle = productSettings?.data.association_text
  const addToCartButtonOnAssociatedItem =
    productSettings?.data?.display_add_to_cart_button_on_associated_item
  const productLayout = productSettings?.data?.product_layout
  const displayHero = productSettings?.data?.display_hero_section
  const hasQtySelector = main?.data?.has_quantity_selector
  const addFromPack = main?.data?.only_add_with_pack
  const aspectRatio = thumbnailRatio(main?.data?.thumbnail_ratio)
  const thumbWidth = main?.data?.small_image_size
  const cardWidth = main?.data?.medium_image_size
  const largeImgWidth = main?.data?.large_image_size
  const gridItemWidth = columnLayout(main?.data?.page_shop_desktop_columns)
  const isFiveColumns = gridItemWidth === '20%'
  const { columnLeft, columnRight } = columnGridLayout(
    productSettings?.data?.column_layout
  )
  const [fromApp, setFromApp] = useState(true)
  const [currentItem, setCurrentItem] = useState(product?.item)
  const associations = currentItem && currentItem.associations
  const [isBuyableProduct, setIsBuyableProduct] = useState(false)
  const carouselMain = useRef<GliderMethods>(null)
  const carouselThumbs = useRef<GliderMethods>(null)
  const [currentThumb, setCurrentThumb] = useState(0)
  const discountPriceFormat = main?.data?.discounted_price_display_format
  const displayFlexPrice = main?.data?.display_flex_price_a_day
  const isDisplayTotalRentPrice =
    productSettings?.data?.display_total_rental_price
  const currentPromotion = promotions?.currentPromotion
  const isAvailabilityChecker = productSettings?.data?.availability_checker
  const likingEnabled = main?.data?.wishlist_enabled && userIsLoggedIn
  const addToCartBtnOpts = btnOptions(productSettings?.data?.add_to_cart_button)
  const [availabilityChecker, setAvailabilityChecker] = useState(false)
  const [unavailability, setUnavailability] = useState([])
  const [selectedTakeBackOrRental, setSelectedTakeBackOrRental] = useState(0)
  const rentOnly = !takeBackAvailability && availability
  const secondHandOnly = takeBackAvailability && !availability
  const [selectedQuality, setSelectedQuality] = useState('')
  const [selectedQualityObject, setSelectedQualityObject] = useState(null)
  const [showQualities, setShowQualities] = useState(true)
  const [currentSizeQualities, setCurrentSizeQualities] = useState([])
  const [currentVariantCode, setCurrentVariantCode] = useState('')
  const [noMoreStockAvailable, setNoMoreStockAvailable] = useState(false)
  const [currentSku, setCurrentSku] = useState('')
  const [gliderReady, setGliderReady] = useState(
    !parameters?.items?.enableTakeBack ? true : false
  )
  const [
    remainSecondHandSkusAfterCheckCart,
    setRemainSecondHandSkusAfterCheckCart,
  ] = useState([])
  const states = productCheckState(takeback?.data)
  const isSecondHand = parameters?.items?.enableTakeBack
  const [currentSecondHandDescription, setCurrentSecondHandDescription] =
    useState('')
  const [typeInCart, setTypeInCart] = useState(null)
  const [fireViewItemGAEvent, setFireViewItemGAEvent] = useState(false)

  const dispatch = useDispatch()
  const [reserveModalOpen, setReserveModalOpen] = useState(false)
  const [reserveError, setReserveError] = useState<boolean | number>(false)
  const reservationCreating = useSelector(
    (state: RootState) => state.reservations?.creating ?? false
  )
  const takeBackStockMap = takeBackLP?.takeBackStockMap as
    | Map<string, any>
    | undefined

  const firstAvailablePuid = useMemo(() => {
    if (
      !main?.data?.enable_reservation ||
      !takeBackStockMap ||
      !currentItem?.variants
    )
      return null
    const skus = Object.values(currentItem.variants)?.map((v: any) => v?.sku)
    for (const sku of skus) {
      const entry = takeBackStockMap.get(sku)
      if (entry?.productsByQuality?.length) {
        for (const q of entry.productsByQuality) {
          if (q.products?.length) return q.products[0].puid
        }
      }
    }
    return null
  }, [currentItem?.variants, takeBackStockMap])

  const reservationDays = main?.data?.number_of_reservation_days || 5

  const handleReserveConfirm = useCallback(() => {
    if (!firstAvailablePuid) return
    setReserveError(false)
    const locale = router.locale
    const prismicLocale = `${locale}-${locale}`
    ;(dispatch as any)(createReservation(firstAvailablePuid, prismicLocale))
      .then(() => {
        setReserveModalOpen(false)
        setProductAlreadyReserved(true)
      })
      .catch((error) => {
        setReserveError(error?.response?.status || true)
      })
  }, [dispatch, firstAvailablePuid, router.locale])

  const baseUrl =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : ''
  const selectedStoreWarehouseId = stores?.selectedStore?.warehouseId
  const customWarehouseId = process.env.CUSTOM_WAREHOUSE ?? null
  const warehouseId = selectedStoreWarehouseId ?? customWarehouseId

  const isEnableChooseStartingDate = parameters?.items?.enableChooseStartingDate
  const currentFullUrl = baseUrl + router.asPath

  const secondHandStock = useMemo(
    () => stock?.stock?.filter((skuStock) => !!skuStock?.secondHand),
    [stock?.stock]
  )
  // Keep a ref always pointing to the latest secondHandStock so async
  // callbacks (e.g. getSkuAndTBPStock) don't close over a stale empty array
  // when stock.stock is populated after the effect first fires.
  const secondHandStockRef = useRef(secondHandStock)
  useEffect(() => {
    secondHandStockRef.current = secondHandStock
  }, [secondHandStock])
  const isSki = product?.item?.ski // TODO change this with Sylius value
  const [
    currentItemAndAssociationTBStock,
    setCurrentItemAndAssociationTBStock,
  ] = useState([])

  const showBreadCrumb = main?.data?.show_breadcrumb_product_page === true

  const isLiked = products.likedProductsSet.has(product.item?.id)

  const [breadCrumbItems, mainTaxon] = useMemo(() => {
    if (!taxons.length || !taxons?.[0]?.children?.length || !product.item)
      return []
    const _breadCrumbItems: TBreadCrumbItem[] = [
      { name: t('texts:general:home'), href: '/' },
    ]

    const taxonsMap = new Map(
      taxons[0].children.map((taxon) => [taxon.code, taxon])
    )
    const mainTaxons = product.item.taxons.others
      .map((code) => taxonsMap.get(code))
      .filter((taxon) => taxon)

    const categoryTaxon = mainTaxons?.[0]
    const firstIsMainCategory = categoryTaxon?.children?.length === 0

    if (categoryTaxon) {
      const categoryHref = `/${categoryTaxon.slug}`
      const name = formatBreadCrumbTaxonName(categoryTaxon.name)

      _breadCrumbItems.push({
        name,
        href: categoryHref,
      })

      const subCategoryTaxon = firstIsMainCategory
        ? mainTaxons?.[1]
        : categoryTaxon.children.find((taxon) =>
            product.item.taxons.others.includes(taxon.code)
          )

      if (subCategoryTaxon) {
        const name = formatBreadCrumbTaxonName(subCategoryTaxon.name)
        _breadCrumbItems.push({
          name,
          href: `${!firstIsMainCategory ? categoryHref : ''}/${
            subCategoryTaxon.slug
          }`,
        })
      }
    }

    return [_breadCrumbItems, categoryTaxon]
  }, [taxons, product])

  const isNewButRepairedTaxon = mainTaxon?.slug === NEW_BUT_REPAIRED_TAXON_SLUG

  const hrefLangs = useMemo(() => {
    const hrefLanguages = main?.data?.href_languages
    if (hrefLanguages) {
      const text = prismicText(hrefLanguages)
      return text ? text.split(',') : []
    }
    return []
  }, [main])

  const [productAlreadyReserved, setProductAlreadyReserved] = useState(false)
  useEffect(() => {
    if (!product?.item) return
    const productVariantsSkus = Object.values(product?.item?.variants)?.map(
      (variant) => variant.sku
    )

    const reservedInStock = stock?.stockMap
      ?.get(productVariantsSkus[0])
      ?.secondHand?.filter((secondHand) => secondHand.reservedCount > 0)

    if (reservedInStock?.length > 0) {
      setProductAlreadyReserved(true)
    }
  }, [product?.item, stock?.stockMap])

  const handleLikeToggle = () => {
    const _product = product.item as any
    if (isLiked && _product) {
      removeFromWishList(_product)
    } else {
      addToWishList(_product)
    }
  }

  useEffect(() => {
    setCurrentItem(undefined)
    setQuantity(0)
    setAvailability(false)
    setTakeBackAvailability(false)
    setMinPrice(0)
    setOriginalPrice(0)
    setTakeBackPrice(0)
    setTakeBackPriceMinTtc(0)
    setTakeBackPriceMin(0)
    setSelectedTakeBackOrRental(0)
    setSelectedQuality('')
    setSelectedQualityObject(null)
    setShowQualities(true)
    setCurrentSizeQualities([])
    setCurrentVariantCode('')
    setCurrentSku('')
    setCurrentSecondHandDescription('')
    setTypeInCart(null)
    setFireViewItemGAEvent(false)
    setNoMoreStockAvailable(false)
    setRemainSecondHandSkusAfterCheckCart([])
    setProductAlreadyReserved(false)
    setCurrentItemAndAssociationTBStock([])
    setCurrentThumb(0)
    setAvailabilityChecker(false)
    setUnavailability([])
    setIsBuyableProduct(false)
    setGliderReady(!parameters?.items?.enableTakeBack ? true : false)
    trackPageView({ documentTitle: `${slug}` })
    getTaxons()
    getProductsBySlug(slug.product as string)
    window?.scrollTo(0, 0)
  }, [slug.product])

  // Clear the fetched product from the store when leaving the product page so
  // a previously viewed product can never be used to seed the next visit
  // (e.g. navigating from "my reservations" to a product detail page).
  useEffect(() => {
    return () => {
      dispatch(resetSingleProduct())
    }
  }, [dispatch])

  useEffect(() => {
    if (mainTaxon) {
      getTaxonsSizes(mainTaxon.slug)
    }
  }, [mainTaxon])

  useEffect(() => {
    if (
      product?.item &&
      cart?.item &&
      process.env.NEXT_PUBLIC_GA_ID &&
      !fireViewItemGAEvent &&
      ((isSecondHandOnly && takeBackPrice) || !isSecondHandOnly)
    ) {
      setFireViewItemGAEvent(true)
    }
  }, [product?.item, cart?.item, takeBackPrice])

  useEffect(() => {
    if (fireViewItemGAEvent) {
      let price = 0
      const quantity = 1
      const variant = Object.values(product.item.variants)[0]

      if (isSecondHandOnly) {
        price = numberToPrice(takeBackPrice)
      } else if (isDateToDate) {
        const { startLeasingDate, endLeasingDate } = cart.item
        const numberOfDays =
          dayjs(endLeasingDate, 'DD/MM/YYYY').diff(
            dayjs(startLeasingDate, 'DD/MM/YYYY'),
            'day'
          ) + 1
        const priceByDay = variant.price.current
        price = numberToPrice(priceByDay * numberOfDays)
      }

      const firstVariant = Object.values(product.item.variants)[0]
      const gaParams = {
        currency: cart.item.currency,
        value: price * quantity,
        items: [
          {
            ['item_name']: product.item.name,
            ['item_id']: isChalhoub ? firstVariant.sku : product.item.code,
            ['item_variant']: isChalhoub && firstVariant.code,
            price,
            quantity: 1,
          },
        ],
      }

      const cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams)
      tracker(GAEvent.VIEW_ITEM, cleanGAParams)
      safeDataLayerPush(getViewItemGtmData(quantity, product, firstVariant))
    }
  }, [fireViewItemGAEvent])

  useEffect(() => {
    dispatch(
      SAVE_PRISMIC_DOCUMENTS({
        general: main?.data,
        funnel: funnel?.data,
        basket: basket?.data,
        prismicProduct: productSettings?.data,
        instore: inStoreText?.data,
      })
    )
  }, [funnel, main, basket, productSettings, inStoreText])

  const commonInfo = useMemo(
    () => ({
      datas:
        pageData?.data?.common_informations || main?.data?.common_informations,
      layout:
        pageData?.data?.common_informations_layout ||
        main?.data?.common_informations_layout,
      additionalContent:
        pageData?.data?.informations_additional_content ||
        main?.data?.informations_additional_content,
      shippingCosts: productSettings?.data?.shipping_costs,
    }),
    [main?.data, pageData?.data, productSettings?.data]
  )

  useEffect(() => {
    if (typeof product?.item !== 'undefined') {
      if (selectedTakeBackOrRental === 1) {
        setGliderReady(false)
        const getSkuAndTBPStock = async () => {
          const SKUArray = await getSkus(product?.item)
          let takeBackStockPreLoaded
          if (SKUArray.length > 0) {
            const data = {
              lizeeSKUs: SKUArray,
            }
            takeBackStockPreLoaded = await getTakeBackStock(data)
            setCurrentItemAndAssociationTBStock(
              takeBackStockPreLoaded?.response
            )
          }
          const productToChangeForPreSelection = { ...product?.item }
          const currentProductSkus = Object.values(
            productToChangeForPreSelection.variants
          ).map((variant) => variant.sku)
          // Use the ref so we always get the latest secondHandStock, even if
          // stock.stock populated after this async callback started.
          const secondHandStockForThisProduct =
            secondHandStockRef.current.filter((skuStock) =>
              currentProductSkus.includes(skuStock.lizeeSKU)
            )

          handlePreselectedSizeAndCondition(
            secondHandStockForThisProduct,
            productToChangeForPreSelection,
            takeBackStockPreLoaded?.response,
            states,
            cart,
            setOriginalPrice,
            setCurrentVariantCode,
            setCurrentSizeQualities,
            setShowQualities,
            setSelectedQuality,
            setSelectedQualityObject,
            setCurrentSku,
            setCurrentItem,
            setCurrentSecondHandDescription,
            setTakeBackPrice,
            setGliderReady,
            setNoMoreStockAvailable,
            setRemainSecondHandSkusAfterCheckCart,
            router
          )
        }
        getSkuAndTBPStock()
      } else {
        setCurrentItem(product.item)
        setGliderReady(true)
        setQuantity(
          cart &&
            cart?.item &&
            cart?.item?.items?.length > 0 &&
            typeof cart?.item?.items?.find(
              (el) => el.product.code === product?.item?.code
            ) !== 'undefined'
            ? cart.item.items?.find(
                (el) => el.product.code === product?.item?.code
              )?.quantity
            : 0
        )
      }
      if (currentItem) {
        const currentTypeInCart = getCurrentProductTypeInCart(currentItem, cart)
        setTypeInCart(currentTypeInCart)
      }
    }
  }, [product?.item, selectedTakeBackOrRental, cart?.item?.items])

  useEffect(() => {
    if (typeof product?.item !== 'undefined') {
      if (selectedTakeBackOrRental === 1) {
        const productToChangeAfterAddedItemInCart = { ...product?.item }
        const currentProductSkus = Object.values(
          productToChangeAfterAddedItemInCart.variants
        ).map((variant) => variant.sku)
        const secondHandStockForThisProduct = secondHandStock.filter(
          (skuStock) => currentProductSkus.includes(skuStock.lizeeSKU)
        )
        setGliderReady(false)
        handlePreselectedSizeAndCondition(
          secondHandStockForThisProduct,
          productToChangeAfterAddedItemInCart,
          takeBackLP?.takeBackStock,
          states,
          cart,
          setOriginalPrice,
          setCurrentVariantCode,
          setCurrentSizeQualities,
          setShowQualities,
          setSelectedQuality,
          setSelectedQualityObject,
          setCurrentSku,
          setCurrentItem,
          setCurrentSecondHandDescription,
          setTakeBackPrice,
          setGliderReady,
          setNoMoreStockAvailable,
          setRemainSecondHandSkusAfterCheckCart,
          router
        )
      }
      if (currentItem) {
        const currentTypeInCart = getCurrentProductTypeInCart(currentItem, cart)
        setTypeInCart(currentTypeInCart)
      }
    }
  }, [cart?.item?.items, secondHandStock])

  useEffect(() => {
    if (
      store !== 'lunettes-de-zac' ||
      typeof window === 'undefined' ||
      !product?.item?.code
    )
      return

    const productVariantKeys = Object.keys(product.item.variants)
    const productVariantSku = product.item.variants[productVariantKeys[0]].sku
    let savedImages = getSavedProductImages(product.item.code)
    if (!savedImages?.length) {
      // get images from stock
      savedImages = stock.stockMap
        ?.get(productVariantSku)
        ?.secondHand?.flatMap((secondHand) => secondHand.images)
    }
    if (savedImages?.length > 0) {
      setCurrentItem((previousItem) =>
        previousItem || product?.item
          ? {
              ...(previousItem || product.item),
              images: savedImages,
            }
          : previousItem
      )
    }
  }, [product?.item?.code, product?.item, stock?.stockMap])

  useEffect(() => {
    const sourceItem = currentItem || product?.item

    if (
      store !== 'lunettes-de-zac' ||
      typeof window === 'undefined' ||
      !sourceItem?.code ||
      !Array.isArray(sourceItem?.images) ||
      sourceItem.images.length === 0
    )
      return

    saveProductImages(sourceItem.code, sourceItem.images)
  }, [currentItem?.code, currentItem?.images, product?.item])

  useEffect(() => {
    if (selectedQuality) {
      const chosenQualityObject = getChosenQualityObject(
        selectedQuality,
        currentSizeQualities,
        currentSku,
        secondHandStock
      )
      setSelectedQualityObject(chosenQualityObject)
    } else {
      setSelectedQualityObject(null)
    }
  }, [selectedQuality])

  const handleSizeSelected = (sku) => {
    const qualitiesArray = createProductsQualityArrayBySize(
      takeBackLP?.takeBackStock,
      sku,
      states,
      cart
    )
    const originalPriceFromCurrentItem = handleTakeBackOriginalPrice(
      currentItem,
      sku
    )
    setOriginalPrice(originalPriceFromCurrentItem)
    setCurrentVariantCode(
      Object.values(currentItem.variants)?.find((el) => el.sku === sku).code
    )
    setCurrentSizeQualities(qualitiesArray)
    setShowQualities(true)
    setSelectedQuality('')
    setCurrentSku(sku)

    // in order to pre-select one condition when user changes size according filter and available conditions
    const availableConditions = qualitiesArray
      .filter((quality) => !quality.disabled)
      .map((quality) => quality.quality)
    const filteredConditions =
      getAvailableFilteredConditions(availableConditions)
    const chosenCondition = getLowestConditionByConditions(
      filteredConditions
        ? getAvailableFilteredConditions(availableConditions)
        : availableConditions
    )
    const preselectedCondition = qualitiesArray.find(
      (qualityInfo) => qualityInfo.quality === chosenCondition
    )
    handleStateSelected(preselectedCondition)
  }

  const handleStateSelected = (quality) => {
    const numberInCart = currentQualityInCart(quality.quality, currentSku, cart)
    const secondHandDescription =
      quality?.products !== undefined && quality?.products[numberInCart]?.note
    const item = { ...product?.item }
    const images = []
    images.push(...quality?.products[numberInCart]?.images)
    images.push(...item.images)
    item.images = images
    setCurrentItem(item)
    setSelectedQuality(quality?.quality)
    setCurrentSecondHandDescription(secondHandDescription)
    const {
      resalePrice: currentPricesByCondition,
      taxIncludedInPrice,
      taxRate,
    } = Object.values(currentItem.variants)?.find((el) => el.sku === currentSku)
    let priceHt = currentPricesByCondition[quality.quality]
    let priceTtc = priceHt
    const pricingWithTax = getPricingWithTaxInfo(
      priceHt,
      taxIncludedInPrice,
      taxRate
    )
    priceHt = pricingWithTax.priceHt
    priceTtc = pricingWithTax.priceTtc

    setTakeBackPrice(priceHt)
    setTakeBackPriceMinTtc(priceTtc)
  }

  const onQuantityChange = (quantity: number) => {
    const productCode = product.item.code
    const productInCart =
      cart &&
      cart.item &&
      cart.item?.items?.length > 0 &&
      typeof cart.item.items?.find((el) => el.product.code === productCode) !==
        'undefined' &&
      cart.item.items?.find((el) => el.product.code === productCode)
    const firstVariant =
      Object.keys(product.item.variants)[0] !== '0'
        ? Object.keys(product.item.variants)[0]
        : product.item.variants[0].code
    const productInCartFirstVariant =
      productInCart && Object.keys(productInCart?.product?.variants)[0]

    const response = addToCartUtility(
      firstVariant,
      quantity,
      cart,
      parameters,
      productInCart,
      false,
      stock
    )

    trackEvent({
      category: 'Products',
      action: `Quantity changed`,
      name: `product ${product?.item?.name}`,
      value: quantity,
    })

    const unitaryPrice = numberToPrice(
      productInCart?.product?.variants[productInCartFirstVariant]?.price
        ?.current
    )
    const totalPrice = unitaryPrice * quantity

    if (availability) {
      switch (response.message) {
        case 'limit':
        case 'max':
        case 'add':
          trackEvent({
            category: 'Add to Cart',
            action: `${product?.item?.name}`,
            name: `${router.pathname}`,
            value: totalPrice,
          })

          if (response.productInCart) {
            changeProductQuantityInCart(
              productInCart.id,
              { quantity },
              GAEvent.ADD_TO_CART,
              stock
            )

            pushInstruction(
              'addEcommerceItem',
              productInCart?.product?.variants[productInCartFirstVariant]?.sku,
              productInCart?.product?.name,
              productInCart?.product?.taxons?.main,
              unitaryPrice,
              quantity
            )
            pushInstruction(
              'trackEcommerceCartUpdate',
              numberToPrice(cart?.item?.totals?.total)
            )
          } else {
            if (product.item.isSimpleProduct) {
              addProductToCart({
                productCode: productCode,
                quantity: quantity,
              })
              pushInstruction(
                'addEcommerceItem',
                product?.item?.variants[firstVariant]?.sku,
                product?.item?.name,
                product?.item?.taxons?.main,
                numberToPrice(
                  product?.item?.variants[firstVariant]?.price?.current
                ),
                quantity
              )
              pushInstruction(
                'trackEcommerceCartUpdate',
                numberToPrice(cart.item.totals.total)
              )
            } else {
              addProductToCart({
                productCode: productCode,
                quantity: quantity,
                variantCode: firstVariant,
              })
              pushInstruction(
                'trackEcommerceCartUpdate',
                numberToPrice(cart.item.totals.total)
              )
            }
          }
          break
        case 'remove':
          changeProductQuantityInCart(
            productInCart.id,
            { quantity },
            GAEvent.REMOVE_FROM_CART,
            stock
          )
          trackEvent({
            category: 'Remove from Cart',
            action: `${product?.item?.name}`,
            name: `${router.pathname}`,
            value: totalPrice,
          })
          pushInstruction(
            'addEcommerceItem',
            productInCart?.product?.variants[productInCartFirstVariant]?.sku,
            productInCart?.product?.name,
            productInCart?.product?.taxons?.main,
            unitaryPrice,
            quantity
          )
          pushInstruction(
            'trackEcommerceCartUpdate',
            numberToPrice(cart.item.totals.total)
          )
          break
        case 'delete':
          trackEvent({
            category: 'Delete from Cart',
            action: `${product?.item?.name}`,
            name: `${router.pathname}`,
            value: totalPrice,
          })
          removeProductFromCart(productInCart)
          pushInstruction(
            'removeEcommerceItem',
            productInCart?.product?.variants[productInCartFirstVariant]?.sku
          )
          pushInstruction(
            'trackEcommerceCartUpdate',
            numberToPrice(cart.item.totals.total)
          )
          break
        default:
          break
      }

      setQuantity(quantity)
      setOpenModal(false)
    }
  }

  // add product with a variant
  const addProductWithSize = (
    variantCode: string,
    variantName: string,
    quantity: number,
    isTryOut?: boolean
  ) => {
    const productInCart =
      cart &&
      cart.item &&
      cart.item.items?.length > 0 &&
      typeof cart.item.items?.find(
        (el) => el.product.variants[0].code === variantCode
      ) !== 'undefined' &&
      cart.item.items?.find((el) => el.product.variants[0].code === variantCode)
    let inStock = 0
    if (productInCart) {
      inStock = checkStockQuantity(stock, productInCart.product.variants[0])
    }
    const response = addToCartUtility(
      variantName,
      quantity,
      cart,
      parameters,
      productInCart,
      isTryOut,
      inStock
    )

    const unitaryPrice = numberToPrice(
      productInCart?.product?.variants[variantCode]?.price?.current
    )
    const totalPrice = unitaryPrice * quantity

    if (response.productInCart) {
      changeProductQuantityInCart(
        productInCart.id,
        { quantity },
        GAEvent.ADD_TO_CART,
        inStock
      )
      trackEvent({
        category: 'Add to Cart',
        action: `${product?.item?.name}`,
        name: `${router.pathname}`,
        value: totalPrice,
      })
      pushInstruction(
        'addEcommerceItem',
        productInCart?.product?.variants[0]?.sku,
        productInCart?.product?.name,
        productInCart?.product?.taxons?.main,
        unitaryPrice,
        quantity
      )
      pushInstruction(
        'trackEcommerceCartUpdate',
        numberToPrice(cart.item.totals.total)
      )
    } else {
      pushInstruction(
        'addEcommerceItem',
        product.item?.variants[variantCode]?.sku,
        product.item?.name,
        product.item?.taxons?.main,
        numberToPrice(product.item?.variants[variantCode]?.price?.current),
        quantity
      )
      pushInstruction(
        'trackEcommerceCartUpdate',
        numberToPrice(cart.item.totals.total)
      )
      if (response.message === 'add' || response.message === 'limit') {
        trackEvent({
          category: 'Add to Cart',
          action: `${product?.item?.name}`,
          name: `${router.pathname}`,
          value: totalPrice,
        })
        addProductToCart({
          productCode: product.item.code,
          quantity: quantity,
          variantCode: variantCode,
        })
      } else if (response.message === 'add tryout') {
        trackEvent({
          category: 'Add to Cart for tryout',
          action: `${product?.item?.name}`,
          name: `${router.pathname}`,
          value: numberToPrice(
            product.item?.variants[variantCode]?.price?.current * quantity
          ),
        })
        addProductToCart({
          productCode: product.item.code,
          quantity: quantity,
          variantCode: variantCode,
          withTryingOn: true,
        })
      }
    }

    setOpenModal(false)
  }

  useEffect(() => {
    const priceArray = []
    const originalPriceArray = []
    const takeBackPriceArray = []
    let takeBackMinPriceArray: ReturnType<typeof productLowestPrice> = []

    if (
      product &&
      typeof product?.item !== 'undefined' &&
      stock?.stock &&
      stock?.stock?.length > 0
    ) {
      // Handle rental availability
      const productAvailability = checkProductAvailability(stock, product?.item)
      setAvailability(productAvailability.available)
      // Handle second hand availability
      setTakeBackAvailability(productAvailability.secondHandAvailable)
      // Handle Prices
      for (const variantKey in product?.item?.variants) {
        const variant = product?.item?.variants[variantKey]
        if (!variant?.purchase) {
          priceArray.push(variant?.price?.current)
          setIsBuyableProduct(false)
        } else {
          priceArray.push(variant?.purchasePrice)
          setIsBuyableProduct(true)
        }
        originalPriceArray.push(variant?.originalPrice?.current)
      }
      // The price displayed on loading is the lowest price between all the variants
      setMinPrice(Math.min(...priceArray))
      // Same logic for the original price
      setOriginalPrice(Math.min(...originalPriceArray))
      // Same logic for second hand prices with takeBackAvailability in mind
      if (productAvailability.secondHandAvailable) {
        Object.values(product.item?.variants).forEach((variant) => {
          if (variant?.resalePrice) {
            Object.values(variant?.resalePrice).forEach((price) => {
              takeBackPriceArray.push(price)
            })
          }
        })
      }
      // find lowest 2nd hand price available
      if (productAvailability.secondHandAvailable) {
        takeBackMinPriceArray = productLowestPrice(product?.item, takeBackLP)
      }
      if (takeBackMinPriceArray.length > 0) {
        // find the element with minimum price on takeBackMinPriceArray
        const foundTakeBackMinPriceObj = takeBackMinPriceArray.reduce(
          (prev, curr) => (prev.price < curr.price ? prev : curr),
          takeBackMinPriceArray[0]
        )

        const { price, taxIncludedInPrice, taxRate } = foundTakeBackMinPriceObj
        const pricingWithTax = getPricingWithTaxInfo(
          price,
          taxIncludedInPrice,
          taxRate
        )
        setTakeBackPriceMin(pricingWithTax.priceHt)
        setTakeBackPriceMinTtc(pricingWithTax.priceTtc)
      }
    }
  }, [product.item, stock, takeBackLP])

  useEffect(() => {
    // Check availability for product with only one variant
    if (
      isAvailabilityChecker &&
      !availability &&
      product?.item?.variants &&
      Object.values(product?.item?.variants)?.length === 1
    ) {
      setAvailabilityChecker(true)
      const checkProductVariantStock = async () => {
        const response = await getProductVariantAvailability(
          Object.values(product.item.variants)[0].sku
        )
        if (response.type === 'GET_STOCK_AVAILABILITY_SUCCESS') {
          setUnavailability(response.availabilities)
        }
      }
      checkProductVariantStock()
    }
  }, [product.item])

  useEffect(() => {
    // Turns out that opening a tab start your history at 1
    if (window?.history?.length <= 2) {
      setFromApp(false)
    }
  }, [fromApp])

  useEffect(() => {
    if (rentOnly) {
      setSelectedTakeBackOrRental(0)
      setGliderReady(true)
    }
    if (secondHandOnly) setSelectedTakeBackOrRental(1)
  }, [secondHandOnly, rentOnly])

  const handleCloseInStoreModal = () => {
    setOpenInStoreModal(false)
  }

  const handleOpenInStoreModal = () => {
    setOpenInStoreModal(true)
  }

  useEffect(() => {
    if (currentItem?.images) {
      for (
        let index = 0;
        index < Math.ceil(currentItem?.images?.length / THUMBS_BY_SLIDES);
        index++
      ) {
        if (Math.floor(currentThumb / THUMBS_BY_SLIDES) === index) {
          carouselThumbs.current?.scrollItem(index, true)
        }
      }
    }
  }, [currentThumb, currentItem?.images])

  const handleCarouselMainNav = (pos) => {
    setCurrentThumb(pos.detail.slide)
  }

  const handleCarouselThumbNav = (pos) => {
    carouselMain.current?.scrollItem(pos)
    setCurrentThumb(pos)
  }

  const start = dayjs(cart?.item?.startLeasingDate, 'DD/MM/YYYY')
  const end = dayjs(cart?.item?.endLeasingDate, 'DD/MM/YYYY')
  const dayRange = end.diff(start, 'day') + 1

  const handleTakeBackAndRental = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setSelectedTakeBackOrRental(newValue)
  }

  const handleChangeCurrentItem = (newItem) => {
    setCurrentItem({ ...newItem })
  }

  const secondHandDescriptionPosition =
    takeback?.data?.take_back_description_position

  const ProductDesc = () => (
    <>
      <Typography
        variant="body1"
        component="div"
        className={clsx(
          'product__desc',
          classes.shopApiContent,
          productClasses.desc,
          productLayout && isMobile && productClasses.smallText
        )}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: currentItem.description,
          }}
        />
      </Typography>
      {isSecondHand &&
        currentSecondHandDescription?.length > 0 &&
        selectedTakeBackOrRental === 1 &&
        (!secondHandDescriptionPosition ||
          secondHandDescriptionPosition ===
            SecondHandDescriptionPosition.BelowProductDescription) && (
          <>
            <Typography
              variant="body1"
              component="div"
              className={clsx('product__desc', 'take_back_description')}
            >
              <CMSText
                asText
                data={takeback?.data?.take_back_description}
                defaultText={t('texts:takeBack:take_back_description')}
              />
            </Typography>
            <Typography
              variant="body1"
              component="div"
              className={clsx('product__desc')}
            >
              {currentSecondHandDescription.length > 0 &&
                currentSecondHandDescription}
            </Typography>
          </>
        )}
    </>
  )

  //This part of code is made to identify the short product shown and its unique variant
  //when there are no size choices, it is needed for the stockAlert component
  const currentProduct = product.loading === false ? product.item : undefined
  const uniSizedProductVariant = currentProduct
    ? Object.values(currentProduct.variants)[0]
    : undefined

  const inStock = uniSizedProductVariant
    ? checkStockQuantity(stock, uniSizedProductVariant)
    : 0
  const shortProduct: shortProduct[] = uniSizedProductVariant
    ? [
        {
          sku: uniSizedProductVariant.sku,
          quantity: inStock,
        },
      ]
    : undefined

  //For now the stock alert is made only for sub stores
  const showStockAlert = isSubscription

  const hasManySizes = currentItem?.variants
    ? Object.keys(currentItem?.variants).length > 1
    : false

  const handleBack = () => {
    fromApp ? router.back() : router.push('/shop')
  }

  const ProductAddToCart = () => {
    return (
      <>
        {availability && takeBackAvailability && (
          <TakeBackAndRentTab
            selectedTakeBackOrRental={selectedTakeBackOrRental}
            handleTakeBackAndRental={handleTakeBackAndRental}
            takeback={takeback}
            t={t}
            typeInCart={typeInCart}
          />
        )}
        {!addFromPack &&
          (availability || hasManySizes ? (
            currentItem &&
            currentItem.variants &&
            selectedTakeBackOrRental === 0 && (
              <Selectors
                cart={cart}
                currentItem={currentItem}
                openModal={openModal}
                productSettings={productSettings}
                stock={stock}
                t={t}
                setOpenModal={setOpenModal}
                addProductWithSize={addProductWithSize}
                main={main}
                hasQtySelector={hasQtySelector}
                availabilityChecker={availabilityChecker}
                availability={availability}
                unavailability={unavailability}
                parameters={parameters}
                quantity={quantity}
                onQuantityChange={onQuantityChange}
                isBuyableProduct={isBuyableProduct}
                isSki={isSki}
                skiText={skiText}
              />
            )
          ) : (
            <>
              {!parameters?.items?.in_store ? (
                productSettings?.data?.availability_checker &&
                selectedTakeBackOrRental === 0 ? (
                  <Selectors
                    cart={cart}
                    currentItem={currentItem}
                    openModal={openModal}
                    productSettings={productSettings}
                    stock={stock}
                    t={t}
                    setOpenModal={setOpenModal}
                    addProductWithSize={addProductWithSize}
                    main={main}
                    hasQtySelector={hasQtySelector}
                    availabilityChecker={availabilityChecker}
                    availability={availability}
                    unavailability={unavailability}
                    parameters={parameters}
                    quantity={quantity}
                    onQuantityChange={onQuantityChange}
                    isBuyableProduct={isBuyableProduct}
                    isSki={isSki}
                    skiText={skiText}
                  />
                ) : (
                  <>
                    {rentOnly && (
                      <Typography
                        variant="h4"
                        className={'product__unavailable'}
                      >
                        <CMSText
                          asText
                          data={productSettings?.data?.sold_out}
                          defaultText={t('texts:packs:victim_of_success')}
                        />
                      </Typography>
                    )}
                    {showStockAlert && (
                      <BackInStockAlert
                        singleProductPrismicData={productSettings?.data}
                        products={shortProduct}
                        url={currentFullUrl}
                        warehouseId={warehouseId}
                      />
                    )}
                  </>
                )
              ) : (
                <div>
                  {showStockAlert && (
                    <BackInStockAlert
                      singleProductPrismicData={productSettings?.data}
                      products={shortProduct}
                      url={currentFullUrl}
                      warehouseId={warehouseId}
                    />
                  )}
                  <InStoreSoldOut
                    datas={inStoreText}
                    layout={productLayout}
                    handleOpenInStoreModal={handleOpenInStoreModal}
                    defaultText={{
                      title: t('texts:instore:product_not_available'),
                      desc: t('texts:instore:paragraph'),
                      cta: t('texts:instore:change_store_cta'),
                    }}
                  />
                </div>
              )}
            </>
          ))}
      </>
    )
  }

  //This part of code has been made to fix the following error
  //"NotFoundError: Failed to execute 'removeChild' on 'Node'"
  //TODO:To avoid the use of this fix, bump react version to 18.x.x
  //and react-i18next version to 12.x.x
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        if (console) {
          console.warn(
            'Cannot remove a child from a different parent',
            child,
            this
          )
        }
        return child
      }
      // eslint-disable-next-line prefer-rest-params
      return originalRemoveChild.apply(this, arguments)
    }

    const originalInsertBefore = Node.prototype.insertBefore
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          console.warn(
            'Cannot insert before a reference node from a different parent',
            referenceNode,
            this
          )
        }
        return newNode
      }
      // eslint-disable-next-line prefer-rest-params
      return originalInsertBefore && originalInsertBefore.apply(this, arguments)
    }
  }

  const secondHandItemCommentNode =
    secondHandDescriptionPosition ===
      SecondHandDescriptionPosition.BelowQualitySelector &&
    currentSecondHandDescription?.length > 0 ? (
      <Box mb={2} className={'second_hand_item_comment'}>
        <Typography
          variant="body1"
          component="div"
          className={clsx('product__desc', 'take_back_description')}
        >
          <CMSText
            asText
            data={takeback?.data?.take_back_description}
            defaultText={t('texts:takeBack:take_back_description')}
          />
        </Typography>
        <Typography
          variant="body1"
          component="div"
          className={clsx('product__desc')}
        >
          {currentSecondHandDescription}
        </Typography>
      </Box>
    ) : null

  const TakeBackSizeRender = (params: {
    secondHandAvailability?: boolean
    displayWarrantyText?: boolean
  }) => {
    if (hidePricingOnGhostUser && !userIsLoggedIn) {
      return (
        <Grid item sm="auto">
          <LoginToSeePriceRow text={accountRes?.data} />
        </Grid>
      )
    } else {
      return (
        <div
          className={clsx(productClasses.selectors, {
            [productClasses.reservationEnabled]: main?.data?.enable_reservation,
            'product__selectors--reservation': main?.data?.enable_reservation,
          })}
        >
          {main?.data && (
            <TakeBackSize
              t={t}
              products={currentItem}
              handleChangeCurrentItem={handleChangeCurrentItem}
              noMoreStockAvailable={noMoreStockAvailable}
              cart={cart}
              addProductToCart={addProductToCart}
              settings={main.data}
              takeback={takeback}
              currentItem={currentItem}
              selectedQuality={selectedQuality}
              handleStateSelected={handleStateSelected}
              handleSizeSelected={handleSizeSelected}
              showQualities={showQualities}
              sku={currentSku}
              currentSizeQualities={currentSizeQualities}
              currentVariantCode={currentVariantCode}
              productSettings={productSettings}
              currentQualityInCart={currentQualityInCart}
              setSelectedQuality={setSelectedQuality}
              availableSkus={remainSecondHandSkusAfterCheckCart}
              displayBraGuidePanel={enableBraSizeGuide}
              aboveAddToCartNode={secondHandItemCommentNode}
              {...params}
            />
          )}
          {main?.data?.enable_reservation && productAlreadyReserved && (
            <Box mt={2}>
              <Alert severity="info" className={classes.reservationAlert}>
                <Link href="/my-reservations">
                  <a
                    data-testid={'go_to_reservations'}
                    onClick={() =>
                      trackEvent({
                        category: 'user Reservations',
                        action: `User go to his Reservations`,
                      })
                    }
                  >
                    <CMSText
                      data={main?.data?.reservations_product_already_reserved}
                      defaultText={t(
                        'texts:reservations:reservations_product_already_reserved'
                      )}
                    />
                  </a>
                </Link>
              </Alert>
            </Box>
          )}
          {userIsLoggedIn &&
            main?.data?.enable_reservation &&
            firstAvailablePuid &&
            !productAlreadyReserved &&
            !noMoreStockAvailable && (
              <Box mt={2}>
                <Button
                  color="primary"
                  variant="outlined"
                  className="product__reserve-btn"
                  fullWidth
                  onClick={() => setReserveModalOpen(true)}
                >
                  {t('texts:reservations:reserve_cta', {
                    days: reservationDays,
                  })}
                </Button>
                <ReservationConfirmModal
                  open={reserveModalOpen}
                  onClose={() => setReserveModalOpen(false)}
                  onConfirm={handleReserveConfirm}
                  loading={reservationCreating}
                  reservationDays={reservationDays}
                  error={reserveError}
                />
              </Box>
            )}
        </div>
      )
    }
  }

  return (
    <Layout
      mainLogo={main?.data?.logo}
      t={t}
      doc={main}
      inStoreText={inStoreText}
      metaTitle={product?.item?.name}
      metaDescriptionProduct={product?.item?.metaDescription}
      metaKeywordsProduct={product?.item?.metaKeywords}
      basket={basket}
      takeback={takeback}
      account={accountRes}
      faq={faqRes}
      banner={banner}
    >
      <HrefLangLinks locales={hrefLangs} />
      <main className={clsx(classes.root, 'page--product')}>
        {!isMobile && !displayHero && (
          <HeroSection
            title={prismicText(
              main?.data?.baseline,
              t('texts:general:baseline')
            )}
            heroImg={main?.data?.hero_banner}
            heroSettings={main?.data}
          />
        )}
        <section
          className={clsx(
            'product__content',
            classes.shopContent,
            classes.shopContentSingle
          )}
        >
          <Container
            maxWidth="xl"
            className={clsx('product__container', classes.shopContainer)}
          >
            {((!isMobile &&
              !displayHero &&
              !isSecondHandOnly &&
              selectedTakeBackOrRental === 0 &&
              !isSubscription) ||
              (!isMobile &&
                !displayHero &&
                !isSecondHandOnly &&
                isSubscription &&
                isEnableChooseStartingDate)) && (
              <>
                <div
                  className={clsx(
                    'shop__planner',
                    classes.shopPlanner,
                    classes.shopPlannerDad
                  )}
                >
                  <DateRangeForm
                    text={main?.data}
                    textFunnel={funnel?.data}
                    t={t}
                    parameters={parameters}
                    scrollTarget={'product-single'}
                  />
                </div>
              </>
            )}
            <Container
              maxWidth="xl"
              className={clsx(
                'product__area',
                classes.shopArea,
                classes.shopAreaSingle
              )}
            >
              {showBreadCrumb ? (
                <Breadcrumbs
                  separator="›"
                  arial-label="Breadcrumb"
                  expandText="..."
                  className="product__breadcrumbs"
                >
                  {breadCrumbItems?.map(({ name, href }) => (
                    <span key={name}>
                      <Link href={href}>{name}</Link>
                    </span>
                  ))}
                </Breadcrumbs>
              ) : (
                <Button
                  className={clsx('product__prev', productClasses.prev)}
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleBack()}
                  size="small"
                  startIcon={<KeyboardArrowLeft />}
                >
                  <CMSText
                    asText
                    data={main?.data?.previous_button}
                    defaultText={t('texts:general:previous_button')}
                  />
                </Button>
              )}
              {product.loading ? (
                <Grid
                  className={clsx('product__grid', productClasses.main)}
                  container
                  spacing={isMobile ? 4 : 8}
                >
                  <Grid item className="product__left" {...columnLeft}>
                    <Skeleton
                      className={productClasses.loadingImg}
                      variant={'rect'}
                      data-ratio={aspectRatio}
                    />
                  </Grid>
                  <Grid item className={'product__right'} {...columnRight}>
                    <Typography
                      variant="h3"
                      component="div"
                      className={productClasses.loadingTitle}
                    >
                      <Skeleton variant="text"></Skeleton>
                    </Typography>
                    {/* Paragraphs */}
                    {Array.from(new Array(12)).map((el, index) => {
                      return (
                        <Typography
                          key={index + 1}
                          variant="body1"
                          component="div"
                        >
                          <Skeleton
                            variant="text"
                            width={`${Math.floor(Math.random() * 100) + 1}%`}
                          />
                        </Typography>
                      )
                    })}
                    <Skeleton
                      className={productClasses.loadingBtn}
                      variant={'rect'}
                      width={200}
                    ></Skeleton>
                  </Grid>
                </Grid>
              ) : (
                currentItem &&
                typeof currentItem !== 'undefined' &&
                typeof product !== 'undefined' &&
                product.item && (
                  <Fade in>
                    <Grid
                      className={clsx(
                        'product__main',
                        productClasses.main,
                        imageFixInProductDetail &&
                          !isMobile &&
                          productClasses.productMainStickyLayout
                      )}
                      container
                      spacing={isMobile ? 4 : 8}
                      data-testid={'product-loaded'}
                      id={'product-single'}
                    >
                      <Grid
                        item
                        className={clsx(
                          productClasses.productLeft,
                          'product__left',
                          imageFixInProductDetail &&
                            !isMobile &&
                            productClasses.productLeftSticky
                        )}
                        {...columnLeft}
                      >
                        {likingEnabled && (
                          <IconButton
                            className={productClasses.likeButton}
                            onClick={handleLikeToggle}
                            data-testid={`like-button-${
                              product.item?.code || ''
                            }`}
                          >
                            {isLiked ? (
                              <FavoriteIcon color="secondary" />
                            ) : (
                              <FavoriteBorderIcon />
                            )}
                          </IconButton>
                        )}
                        {productLayout ? (
                          currentItem.images.map((image, index) => (
                            <div
                              key={`img-${index}`}
                              id={`img-${index}`}
                              data-ratio={aspectRatio}
                              className={productClasses.mediaGap}
                            >
                              <ImgKitHandler
                                alt=""
                                imagePaths={image}
                                classes={productClasses.mediaMain}
                                settings={getProductImageKitSettings(
                                  largeImgWidth,
                                  aspectRatio
                                )}
                              />
                            </div>
                          ))
                        ) : currentItem?.images?.length > 1 ? (
                          <>
                            {gliderReady && (
                              <div className={productClasses.carouselMain}>
                                <Glider
                                  key={`${currentItem.name}-${currentItem?.images?.length}`}
                                  hasArrows
                                  draggable
                                  scrollLock
                                  slidesToShow={1}
                                  iconLeft={<KeyboardArrowLeft />}
                                  iconRight={<KeyboardArrowRight />}
                                  ref={carouselMain}
                                  onSlideVisible={(event) =>
                                    handleCarouselMainNav(event)
                                  }
                                  scrollLockDelay={100}
                                  duration={1}
                                >
                                  {currentItem?.images?.map((image, index) => (
                                    <div key={index}>
                                      <div data-ratio={aspectRatio}>
                                        <ImgKitHandler
                                          settings={getProductImageKitSettings(
                                            largeImgWidth,
                                            aspectRatio
                                          )}
                                          imagePaths={image}
                                          classes={productClasses.mediaMain}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </Glider>
                              </div>
                            )}
                            <Grid
                              className={clsx(
                                productClasses.carouselThumbs,
                                productClasses.carouselThumbsSmall
                              )}
                              container
                              spacing={3}
                            >
                              {gliderReady && (
                                <Glider
                                  key={`${currentItem.name}-${currentItem?.images?.length}`}
                                  hasArrows={
                                    currentItem?.images?.length >
                                      THUMBS_BY_SLIDES && !isMobile
                                      ? true
                                      : false
                                  }
                                  scrollLock
                                  draggable
                                  slidesToShow={THUMBS_BY_SLIDES}
                                  ref={carouselThumbs}
                                  scrollLockDelay={100}
                                  duration={1}
                                  iconLeft={<KeyboardArrowLeft />}
                                  iconRight={<KeyboardArrowRight />}
                                >
                                  {currentItem?.images?.map((image, index) => (
                                    <Box
                                      key={index}
                                      p={1.5}
                                      onClick={() =>
                                        handleCarouselThumbNav(index)
                                      }
                                      className={clsx(
                                        'carousel__thumb',
                                        productClasses.carouselThumb,
                                        currentThumb === index &&
                                          productClasses.carouselThumbCurrent,
                                        'carousel__thumb--active'
                                      )}
                                    >
                                      <div data-ratio={aspectRatio}>
                                        <ImgKitHandler
                                          settings={getProductImageKitSettings(
                                            thumbWidth,
                                            aspectRatio
                                          )}
                                          imagePaths={image}
                                          classes={
                                            productClasses.carouselThumbsImg
                                          }
                                        />
                                      </div>
                                    </Box>
                                  ))}
                                </Glider>
                              )}
                            </Grid>
                          </>
                        ) : (
                          <div className={productClasses.mediaGap}>
                            <div data-ratio={aspectRatio}>
                              <ImgKitHandler
                                alt=""
                                imagePaths={currentItem?.images[0]}
                                classes={productClasses.mediaMain}
                                settings={getProductImageKitSettings(
                                  largeImgWidth,
                                  aspectRatio
                                )}
                              />
                            </div>
                          </div>
                        )}
                      </Grid>
                      <Grid item className={'product__right'} {...columnRight}>
                        {isMobile && productLayout && <ProductDesc />}
                        <div
                          className={clsx(
                            productLayout &&
                              !isMobile &&
                              !imageFixInProductDetail &&
                              productClasses.contentSticky
                          )}
                        >
                          <div
                            className={clsx(
                              productLayout &&
                                isMobile &&
                                productClasses.contentSticky
                            )}
                          >
                            <ProductTitle
                              productLayout={productLayout}
                              isMobile={isMobile}
                              currentItem={currentItem}
                              addFromPack={addFromPack}
                              promotions={promotions}
                              minPrice={minPrice}
                              takeBackPrice={takeBackPrice}
                              main={main}
                              isBuyableProduct={isBuyableProduct}
                              discountPriceFormat={discountPriceFormat}
                              selectedTakeBackOrRental={
                                selectedTakeBackOrRental
                              }
                              takeback={takeback}
                              displayFlexPrice={displayFlexPrice}
                              isDisplayTotalRentPrice={isDisplayTotalRentPrice}
                              productSettings={productSettings}
                              dayRange={dayRange}
                              currentPromotion={currentPromotion}
                              selectedQuality={selectedQuality}
                              originalPrice={originalPrice}
                              takeBackPriceMin={takeBackPriceMin}
                              takeBackPriceMinTtc={takeBackPriceMinTtc}
                              takeBackAvailability={takeBackAvailability}
                              isDisplayedPrice={
                                main?.data?.is_product_price_displayed
                              }
                              isSecondHand={isSecondHand}
                              displayProductState={!isNewButRepairedTaxon}
                              productTaxons={currentItem?.taxons}
                            />
                            <div
                              className={clsx(
                                'product__details',
                                productClasses.content,
                                productLayout &&
                                  productClasses.contentDetailsSticky,
                                !availability && 'product__details--unavailable'
                              )}
                            >
                              {addToCartBtnOpts === 'Both' && (
                                <>
                                  <ProductAddToCart />
                                  {selectedTakeBackOrRental === 1 &&
                                    takeBackAvailability && (
                                      <TakeBackSizeRender />
                                    )}
                                </>
                              )}
                              {addToCartBtnOpts === 'Above' && (
                                <>
                                  <ProductAddToCart />
                                  {selectedTakeBackOrRental === 1 &&
                                    takeBackAvailability && (
                                      <div className={productClasses.selectors}>
                                        <TakeBackSizeRender
                                          secondHandAvailability={
                                            takeBackAvailability
                                          }
                                          displayWarrantyText={
                                            !isNewButRepairedTaxon
                                          }
                                        />
                                      </div>
                                    )}
                                </>
                              )}
                              {currentItem.description && productLayout ? (
                                !isMobile && <ProductDesc />
                              ) : (
                                <ProductDesc />
                              )}
                              <ProductDynamicAlert
                                text={productSettings?.data?.product_alert_text}
                                color="warning"
                                icon={productSettings?.data?.product_alert_icon}
                                condition={
                                  productSettings?.data
                                    ?.show_product_alert_condition
                                }
                                data={product?.item}
                              />
                              {addToCartBtnOpts === 'Both' && (
                                <>
                                  <ProductAddToCart />
                                  {selectedTakeBackOrRental === 1 &&
                                    takeBackAvailability && (
                                      <TakeBackSizeRender />
                                    )}
                                </>
                              )}
                              {addToCartBtnOpts === 'Below' && (
                                <>
                                  <ProductAddToCart />
                                  {selectedTakeBackOrRental === 1 &&
                                    takeBackAvailability && (
                                      <TakeBackSizeRender />
                                    )}
                                </>
                              )}
                            </div>
                          </div>
                          {commonInfo?.additionalContent && (
                            <CMSTextOrImage
                              data={commonInfo?.additionalContent}
                            />
                          )}
                          <CommonInformations {...commonInfo} />
                          <BottomMenuLinks
                            datas={main?.data?.bottom_menu_links}
                          />
                        </div>
                      </Grid>
                      {currentItem.shortDescription && (
                        <Grid
                          item
                          xs={12}
                          className="product__short-description"
                        >
                          <Typography
                            variant={'body1'}
                            component={'div'}
                            className={classes.shopApiContent}
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: currentItem.shortDescription,
                              }}
                            />
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Fade>
                )
              )}
            </Container>
          </Container>
          {showRelatedProducts && associations && (
            <Container maxWidth={'xl'}>
              <div className={clsx('product-related', productClasses.related)}>
                {Object.keys(associations)?.length > 0 && (
                  <>
                    <Typography
                      variant={'h3'}
                      component={'h2'}
                      className={clsx(
                        'product-related__title',
                        productClasses.relatedTitle
                      )}
                    >
                      {!product.loading ? (
                        prismicText(
                          relatedProductsTitle,
                          t('texts:single_product:associations_title')
                        )
                      ) : (
                        <Skeleton variant="text" width="28ch" />
                      )}
                    </Typography>
                    {!product.loading ? (
                      Object.keys(associations).map((association, index) => {
                        return (
                          <Grid
                            key={index}
                            container
                            spacing={3}
                            className={productClasses.associationRow}
                          >
                            {associations[association].map(
                              (relatedItem, index) => {
                                if (relatedItem.enabled) {
                                  let image = null
                                  // if secondHand is enabled, check if the product is available in stock.
                                  // if it's available in stock, show the image of the product from stock.
                                  if (isSecondHand) {
                                    const relatedItemSkus = Object.values(
                                      relatedItem?.variants
                                    ).map(
                                      (relatedItemVariant) =>
                                        relatedItemVariant.sku
                                    )
                                    image = getSecondHandImageForRelatedProduct(
                                      relatedItemSkus,
                                      currentItemAndAssociationTBStock
                                    )
                                  }
                                  return (
                                    <Grid
                                      item
                                      xs={6}
                                      key={index}
                                      lg={isFiveColumns ? 2 : gridItemWidth}
                                      className={
                                        isFiveColumns
                                          ? productClasses.md5
                                          : productClasses.col
                                      }
                                    >
                                      <ProductCard
                                        isRelated
                                        settings={main?.data}
                                        stock={stock}
                                        text={productSettings}
                                        productCode={relatedItem.code}
                                        slug={relatedItem.slug}
                                        name={relatedItem.name}
                                        thumb={image ?? relatedItem?.images}
                                        thumbRatio={aspectRatio}
                                        thumbWidth={cardWidth}
                                        product={relatedItem}
                                        addButton={
                                          addToCartButtonOnAssociatedItem
                                        }
                                        promotions={promotions}
                                        shopData={shop}
                                        isReleatedProduct={true}
                                      />
                                    </Grid>
                                  )
                                }
                              }
                            )}
                          </Grid>
                        )
                      })
                    ) : (
                      <Grid
                        container
                        spacing={3}
                        className={productClasses.associationRow}
                      >
                        {Array.from(new Array(5)).map((el, index) => {
                          return (
                            <Grid
                              item
                              xs={6}
                              key={index}
                              lg={isFiveColumns ? 2 : gridItemWidth}
                              className={
                                isFiveColumns
                                  ? productClasses.md5
                                  : productClasses.col
                              }
                            >
                              <div>
                                <Skeleton
                                  data-ratio={aspectRatio}
                                  variant="rect"
                                />
                                <Skeleton variant="text" width="16ch" />
                                <Skeleton variant="text" width="5ch" />
                              </div>
                            </Grid>
                          )
                        })}
                      </Grid>
                    )}
                  </>
                )}
              </div>
            </Container>
          )}
          <ChangeStoreModal
            handleClose={handleCloseInStoreModal}
            open={openInStoreModal}
            doc={inStoreText}
            t={t}
          />
          <NoMixedBasketModal basket={basket} />
        </section>
      </main>
    </Layout>
  )
}

/**
 * ISR (Incremental Static Regeneration) - Pre-rendère les pages produits à la demande
 * et les met en cache. Réduit drastiquement les appels Prismic : au lieu d'un appel
 * à chaque visite, 1 appel par page produit toutes les 5 minutes (revalidate).
 */
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export async function getStaticProps({ params, locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)
  const enableBraSizeGuide = process.env.ENABLE_BRA_SIZE_GUIDE === 'true'

  let product: Product | null = null
  let page: PrismicPage | null = null
  try {
    product = await productsService.getProductsBySlug(params.product, locale)
    const productTaxonSlug = product?.taxons?.main
      ?.toLowerCase()
      .replace('_', '-')
    if (productTaxonSlug) {
      page = await getByUID(client, 'pages', productTaxonSlug, lang)
    }

    // eslint-disable-next-line no-empty
  } catch (e) {}

  if (!product) {
    return { notFound: true as const, revalidate: 60 }
  }

  const takeback = await getSingleDocument(client, lang, 'take_back')
  const basket: PrismicBasket = await getSingleDocument(client, lang, 'basket')
  const general = await getSingleDocument(client, lang, 'general')
  const funnel: PrismicFunnel = await getSingleDocument(client, lang, 'funnel')
  const skiText = await getSingleDocument(client, lang, 'ski_product_text')
  const productSettings = await getSingleDocument(
    client,
    lang,
    'single_product'
  )
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const accountRes = await getSingleDocument(client, lang, 'account')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')
  const shop = await getSingleDocument(client, lang, 'shop')

  return {
    props: {
      takeback,
      skiText,
      basket,
      main: general as PrismicGeneralConfig,
      pageData: page,
      funnel,
      productSettings,
      accountRes,
      faqRes,
      inStoreText,
      banner,
      shop,
      i18nResources: await getTranslations(locale, ['texts']),
      enableBraSizeGuide,
    },
    revalidate: 300, // ISR : revalide en arrière-plan toutes les 5 min
  }
}

const mapStateToProps = (state: RootState) => ({
  cart: state.cart,
  product: state.product,
  products: state.products,
  /**
   * @todo In the component stock is expected to be a number, but it's in fact an object, find out why?!
   */
  stock: state.stock as any,
  stores: state.stores,
  parameters: state.parameters,
  promotions: state.promotions,
  takeBackLP: state.takeBack,
  taxons: state.taxons.items,
  userIsLoggedIn: state.user.isLoggedIn,
})

const mapDispatchToProps = {
  getProductsBySlug: getProductsBySlug,
  getProductVariantAvailability: getProductVariantAvailability,
  getTakeBackStock: getTakeBackStock,
  dispatchSaveFetchedProduct: saveFetchedProduct,
  getTaxons: getTaxons,
  getTaxonsSizes: getTaxonsSizes,
  addToWishList: addToWishList,
  removeFromWishList: removeFromWishList,
}

export default connect(mapStateToProps, mapDispatchToProps)(Produit)
